import React, { useState } from 'react';
import moment from 'moment';
import { Box, Button, Typography } from '@material-ui/core';

import { ICannedReply } from '../../../interfaces';
import { useConnect } from '../../../context/connect';
import { removeCannedResponse } from '../../../api';
import { Loaders } from '../../Loaders';

import { useStyles } from './style';

export const Item = React.memo(
  ({
    item,
    setDataForUpdate,
    setMode,
  }: {
    item: ICannedReply;
    setDataForUpdate: React.Dispatch<
      React.SetStateAction<ICannedReply | undefined>
    >;
    setMode: React.Dispatch<React.SetStateAction<null | 'create' | 'update'>>;
  }) => {
    const classes = useStyles();
    const [isShowMore, setIsShowMore] = useState<Boolean>(false);
    const [loading, setLoading] = useState<Boolean>(false);

    const [isRemove, setIsRemove] = useState<Boolean>(false);
    const { agentInfo, setCannedResponses, setShortcuts } = useConnect();
    const onDeleteHandler = async () => {
      if (agentInfo) {
        setLoading(true);
        await removeCannedResponse(
          {
            username: agentInfo.user.username,
            id: item.id,
          },
          { setCannedResponses, setShortcuts }
        );

        setLoading(false);
      }
    };

    const content =
      item.canned_reply.length > 300
        ? isShowMore
          ? item.canned_reply
          : item.canned_reply.slice(0, 240).split(' ').slice(0, -1).join(' ') +
            '... '
        : item.canned_reply;
    const btn =
      item.canned_reply.length > 300
        ? isShowMore
          ? ' show less'
          : 'show more'
        : null;
    const date = moment(new Date(item.createdAt * 1000)).format('DD MMM YYYY');
    const name =
      item.updatedBy.first_name || item.updatedBy.first_name
        ? `${item.updatedBy.first_name} ${item.updatedBy.first_name}`.trim()
        : item.updatedBy.username;

    return (
      <Box className={classes.item} pt={1} pb={3}>
        {loading && <Loaders />}
        {isRemove && (
          <Box className={classes.removeConfirmation}>
            <Box textAlign="center">
              <Typography variant={'button'} align="center">
                Are You sure?
              </Typography>
              <Box display={'flex'} mt={2}>
                <Box mr={2}>
                  <Button
                    variant="contained"
                    color={'primary'}
                    size="small"
                    onClick={onDeleteHandler}
                    style={{
                      background: '#f55145',
                      borderRadius: '2px',
                      boxShadow: 'none',
                    }}
                  >
                    Remove
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="contained"
                    color={'primary'}
                    size="small"
                    onClick={() => setIsRemove(false)}
                    style={{
                      background: 'rgb(37, 124, 175)',
                      borderRadius: '2px',
                      boxShadow: 'none',
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        <Box className={classes.item_top} mb={1}>
          <Box
            className={classes.btn}
            mr={1.5}
            onClick={() => {
              setDataForUpdate(item);
              setMode('update');
            }}
          >
            Edit
          </Box>
          <Box
            className={classes.btn}
            onClick={() => {
              setIsRemove(true);
            }}
          >
            Remove
          </Box>
        </Box>
        <Box>
          <Box>
            {content}
            {!!btn && (
              <span
                className={classes.show_more}
                onClick={() => setIsShowMore((prev) => !prev)}
              >
                {btn}
              </span>
            )}
          </Box>

          <Box display="flex" mt={2} alignItems={'center'}>
            {item.shortcuts.map((i) => (
              <Box className={classes.shorcut} key={1}>
                <span className={classes.hash}>#</span>
                {i}
              </Box>
            ))}
            <Box ml={'auto'} textAlign={'right'}>
              <Box className={classes.info_name}>{name}</Box>
              <Box className={classes.additional_info}>
                {item.createdAt === item.updatedAt
                  ? 'Added this response on'
                  : 'Modified this response on'}
              </Box>
              <Box className={classes.additional_info}>{date}</Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
);
